var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('date-time-picker',{attrs:{"date-time":_vm.criterion.value,"showTimePicker":false,"label":_vm.criterion.label},on:{"update:dateTime":function($event){return _vm.$set(_vm.criterion, "value", $event)},"update:date-time":function($event){return _vm.$set(_vm.criterion, "value", $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }